<template>
  <div v-if="lead" v-loading="!lead">
    <el-form
      v-if="lead"
      size="small"
      label-width="auto"
      :model="lead"
      :rules="rules"
    >
      <el-row
        v-for="colGroup in getLeadFields[0]"
        style="margin-bottom: 8px"
        :gutter="6"
      >
        <el-col
          v-for="col in colGroup"
          :span="24 / colGroup.length"
          :xs="24 / colGroup.length"
          :sm="24 / colGroup.length"
          :md="(12 / colGroup.length) * 2"
          :lg="(12 / colGroup.length) * 2"
          :xl="(12 / colGroup.length) * 2"
        >
          <template v-if="col.attribute == 'lead_status_id'">
            <lead-status-select
              v-on:update:leadStatus="setLeadStatus"
              :initial-id="lead.lead_status_id"
              :selected-lead-type="lead.lead_type_id ?? 0"
              style="width: 100%"
              label="Lead Status"
              :use-vuetify="true"
              :error="!lead.lead_status_id"
              :error-messages="
                !lead.lead_status_id ? ['Lead Status is required'] : []
              "
            ></lead-status-select>
            <lost-reason-select
              v-show="showLostReason"
              v-on:update:lostReason="setLostReason"
              :initialId="lead.lost_reason_id"
              :lead-status-id="lead.lead_status_id"
              style="width: 100%: padding: 4px 12px;"
              label="Lost Reason"
              :use-vuetify="true"
              :error="!lead.lost_reason_id"
              :error-messages="
                !lead.lost_reason_id ? ['Lost Reason is required'] : []
              "
            ></lost-reason-select>
            <lost-reason-detail-select
              v-if="
                showLostReason &&
                lead.lost_reason_id &&
                getLostReasonDetails(lead.lost_reason_id).length
              "
              :lost-reason-id="lead.lost_reason_id"
              v-on:update:lostReasonDetail="setLostReasonDetail"
              :initialId="lead.lost_reason_detail_id"
              style="width: 100%: padding: 4px 12px;"
              label="Lost Reason Detail"
              :error="!lead.lost_reason_detail_id"
              :error-messages="
                !lead.lost_reason_detail_id
                  ? ['Lost Reason Detail is required']
                  : []
              "
            ></lost-reason-detail-select>
          </template>

          <template v-if="col.attribute == 'subject'">
            <!-- Cleaner logic for multi-row subjects -->
            <v-textarea
              v-if="subjectRows && subjectRows > 1"
              type="text"
              label="Lead Subject"
              v-model="lead.subject"
              @update:model-value="doChange('subject')"
              density="compact"
              autocomplete="off"
              :rows="subjectRows"
              :error="
                getAppConfig.lead.subjectRequired &&
                (!lead.subject || lead.subject.trim() === '')
              "
              :error-messages="
                getAppConfig.lead.subjectRequired &&
                (!lead.subject || lead.subject.trim() === '')
                  ? ['Subject is required']
                  : []
              "
              hide-details="auto"
            />
            <v-text-field
              v-else
              type="text"
              label="Lead Subject"
              v-model="lead.subject"
              @update:model-value="doChange('subject')"
              density="compact"
              autocomplete="off"
              :error="
                this.getAppConfig.lead.subjectRequired &&
                (!lead.subject || lead.subject.trim() === '')
              "
              :error-messages="
                this.getAppConfig.lead.subjectRequired &&
                (!lead.subject || lead.subject.trim() === '')
                  ? 'Subject is required'
                  : ''
              "
              hide-details="auto"
            />
          </template>

          <template
            v-if="
              col.attribute == 'lead_category_id' &&
              getLeadCategories?.length > 1
            "
          >
            <lead-category-select
              @update:leadCategory="resetLeadCategory"
              :style="{ width: '50%' }"
              :initialId="leadCategory"
              :use-vuetify="true"
            ></lead-category-select>
          </template>
          <template
            v-if="col.attribute == 'lead_type_id' && getLeadTypes?.length > 1"
          >
            <lead-type-select
              v-on:update:leadType="setLeadType"
              v-if="getLeadTypes.length > 1"
              :initialId="lead.lead_type_id"
              :allow-all="false"
              label="Lead Type"
              :style="{ width: '50%' }"
              :lead-category="leadCategory"
              :use-vuetify="true"
            ></lead-type-select>
          </template>
          <template
            v-if="
              col.attribute == 'contact_id' &&
              (contactId === undefined || lead.reservation_id == undefined)
            "
          >
            <contact-select
              :value="lead.contact_id"
              @update:value="setContact"
              :size="'small'"
              :label="'Selected Contact'"
              :use-vuetify="true"
              :error="!lead.contact_id"
              :error-messages="!lead.contact_id ? ['Contact is required'] : []"
            ></contact-select>
          </template>
          <!--Source detail and related-->
          <template v-if="col.attribute == 'source_id'">
            <div>
              <lead-source-select
                :initial-id="lead.source_id"
                @update:leadSource="updateLeadSource"
                label="Lead Source"
                :style="{
                  width: '100%',
                }"
                :use-vuetify="true"
                :clearable="false"
                :error="!lead.source_id"
                :error-messages="
                  !lead.source_id ? ['Lead Source is required'] : []
                "
              ></lead-source-select>
              <agent-select
                v-if="lsRelatedType == 'user'"
                :values="[lead.source_related_id]"
                @update:values="
                  lead.source_related_id = $event.length ? $event[0] : null;
                  doChange('source_related_id');
                "
                :label="'Select Agent'"
                :use-vuetify="true"
                :clearable="true"
                :style="{ width: '100%' }"
              ></agent-select>
              <contact-select
                v-else-if="lsRelatedType == 'contact'"
                :value="lead.source_related_id"
                @update:value="
                  lead.source_related_id = $event;
                  doChange('source_related_id');
                "
                :size="'small'"
                :label="'Select Contact'"
                :use-vuetify="true"
                :style="{ width: '100%' }"
              ></contact-select>
            </div>
            <div>
              <lead-source-detail-select
                v-if="
                  lead.source_id && getLeadSourceDetails(lead.source_id).length
                "
                :lead-source-id="lead.source_id"
                :initial-id="+lead.source_detail_id"
                @update:leadSourceDetail="updateLeadSourceDetail"
                label="Lead Source Detail"
                :style="{
                  width: '100%',
                }"
                :use-vuetify="true"
                :clearable="false"
              ></lead-source-detail-select>
              <agent-select
                v-if="lsdRelatedType == 'user'"
                :values="[lead.source_detail_related_id]"
                @update:values="
                  lead.source_detail_related_id = $event.length
                    ? $event[0]
                    : null;
                  doChange('source_detail_related_id');
                "
                :label="'Select Agent'"
                :use-vuetify="true"
                :clearable="true"
                :style="{ width: '100%' }"
              ></agent-select>
              <contact-select
                v-else-if="lsdRelatedType == 'contact'"
                :value="lead.source_detail_related_id"
                @update:value="
                  lead.source_detail_related_id = $event;
                  doChange('source_detail_related_id');
                "
                :size="'small'"
                :label="'Select Contact'"
                :use-vuetify="true"
                :style="{ width: '100%' }"
              ></contact-select>
            </div>
          </template>

          <!--Closing Source detail and related-->
          <template v-if="col.attribute == 'closing_source_id'">
            <div>
              <lead-source-select
                :initial-id="lead.closing_source_id"
                @update:leadSource="updateClosingLeadSource"
                label="Closing Lead Source"
                :style="{
                  width: '100%',
                }"
                :use-vuetify="true"
                :clearable="false"
                :error="closingSourceRequired && !lead.closing_source_id"
                :error-messages="
                  closingSourceRequired && !lead.closing_source_id
                    ? ['Closing Lead Source is required']
                    : []
                "
              ></lead-source-select>
              <agent-select
                v-if="closingLsRelatedType == 'user'"
                :values="[lead.closing_source_related_id]"
                @update:values="
                  lead.closing_source_related_id = $event.length
                    ? $event[0]
                    : null;
                  doChange('closing_source_related_id');
                "
                :label="'Select Agent'"
                :use-vuetify="true"
                :clearable="true"
                :style="{ width: '100%' }"
              ></agent-select>
              <contact-select
                v-else-if="closingLsRelatedType == 'contact'"
                :value="lead.closing_source_related_id"
                @update:value="
                  lead.closing_source_related_id = $event;
                  doChange('closing_source_related_id');
                "
                :size="'small'"
                :label="'Select Contact'"
                :use-vuetify="true"
                :style="{ width: '100%' }"
              ></contact-select>
            </div>
            <div>
              <lead-source-detail-select
                v-if="
                  lead.closing_source_id &&
                  getLeadSourceDetails(lead.closing_source_id).length
                "
                :lead-source-id="lead.closing_source_id"
                :initial-id="+lead.closing_source_detail_id"
                @update:leadSourceDetail="updateClosingLeadSourceDetail"
                label="Closing Lead Source Detail"
                :style="{
                  width: '100%',
                }"
                :use-vuetify="true"
                :clearable="false"
              ></lead-source-detail-select>
              <agent-select
                v-if="closingLsdRelatedType == 'user'"
                :values="[lead.closing_source_detail_related_id]"
                @update:values="
                  lead.closing_source_detail_related_id = $event.length
                    ? $event[0]
                    : null;
                  doChange('closing_source_detail_related_id');
                "
                :label="'Select Agent'"
                :use-vuetify="true"
                :clearable="true"
                :style="{ width: '100%' }"
              ></agent-select>
              <contact-select
                v-else-if="closingLsdRelatedType == 'contact'"
                :value="lead.closing_source_detail_related_id"
                @update:value="
                  lead.closing_source_detail_related_id = $event;
                  doChange('closing_source_detail_related_id');
                "
                :size="'small'"
                :label="'Select Contact'"
                :use-vuetify="true"
                :style="{ width: '100%' }"
              ></contact-select>
            </div>
          </template>
          <VuetifyDateRangePicker
            v-if="col.attribute == 'interest_start_at'"
            label="Reservation Dates"
            v-model="leadDates"
            @change="changeInterestDates"
            format="M-DD-YYYY"
            :background-color="'#304156'"
            :class="colorClass['interest_start_at']"
            :readonly="readOnly['interest_start_at']"
            :style="{ width: '100%' }"
            :error="
              getAppConfig?.lead?.requireDates === true &&
              (!lead.interest_start_at || !lead.interest_end_at)
            "
            :error-messages="
              getAppConfig?.lead?.requireDates === true &&
              (!lead.interest_start_at || !lead.interest_end_at)
                ? ['Reservation dates are required']
                : []
            "
          />
          <template v-if="col.attribute == 'user_id'">
            <agent-select
              :values="[lead.user_id]"
              @update:values="setAgent"
              :label="'Select Agent'"
              :use-vuetify="true"
              :clearable="false"
              :error="!lead.user_id"
              :error-messages="!lead.user_id ? ['Agent Selection'] : []"
            ></agent-select>
          </template>
          <VuetifyDateTimePicker
            v-if="col.attribute == 'followup_at'"
            label="Follow Up"
            format="M-DD-YYYY hh:mm A"
            v-model="lead.followup_at"
            @update:model-value="doChange('followup_at')"
            placeholder="Select date and time"
            :default-time="defaultTime"
            :error="followupRequired && !lead.followup_at"
            :error-messages="
              followupRequired && !lead.followup_at
                ? ['Follow up date is required']
                : []
            "
            :in-future="true"
            autocomplete="off"
          />
          <VuetifyNumberInput
            v-if="col.attribute == 'quantity_1'"
            label="Adults"
            v-model="lead.quantity_1"
            @update:model-value="doChange('quantity_1')"
            autocomplete="off"
            :min="0"
            :step="1"
            :precision="0"
            :class="colorClass['quantity_1']"
          />
          <VuetifyNumberInput
            v-if="col.attribute == 'quantity_2'"
            label="Children"
            v-model="lead.quantity_2"
            @update:model-value="doChange('quantity_2')"
            autocomplete="off"
            :min="0"
            :step="1"
            :precision="0"
            :class="colorClass['quantity_2']"
          />
          <VuetifyNumberInput
            v-if="col.attribute == 'quantity_3'"
            label="Pets"
            v-model="lead.quantity_3"
            @update:model-value="doChange('quantity_3')"
            autocomplete="off"
            :min="0"
            :step="1"
            :precision="0"
            :class="colorClass['quantity_3']"
          />
          <VuetifyCurrencyInput
            v-if="col.attribute == 'estimated_value'"
            label="Estimated Value"
            @change="mutateEstimatedValue()"
            v-model="estimatedValueFloat"
            :class="colorClass['estimated_value']"
            :readonly="readOnly['estimated_value']"
          />
          <template v-if="col.attribute == 'product_code'">
            <unit-type-select
              :values="[lead.product_code]"
              @update:values="setOriginUnitType"
              :label="'Select Unit Type'"
              :clearable="true"
              :multi="false"
            ></unit-type-select>
          </template>
          <template v-if="col.attribute == 'origin_product_id'">
            <unit-select
              :values="[lead.origin_product_id]"
              @update:values="setOriginUnit"
              :label="'Select Inquiring Unit'"
              :clearable="true"
              :multi="false"
            ></unit-select>
          </template>
          <template v-if="col.attribute == 'final_product_id'">
            <unit-select
              :values="[lead.final_product_id]"
              @update:values="setFinalUnit"
              :label="'Select Booked Unit'"
              :clearable="true"
              :multi="false"
            ></unit-select>
          </template>
          <template v-if="col.attribute == 'reservation_id'">
            <div v-if="needsReservation" class="reservation-required-message">
              This won status requires a linked reservation
            </div>
            <div
              class="reservation-row"
              :class="{ 'reservation-required': needsReservation }"
            >
              <connector-select
                v-model="connectorId"
                size="small"
                select-first-available
                :use-vuetify="true"
                class="reservation-connector"
                :placeholder="'Select Connector'"
              ></connector-select>

              <v-text-field
                type="text"
                label="Booking Code (from PMS)"
                v-model="bookingCode"
                density="compact"
                autocomplete="off"
                hide-details="auto"
                class="reservation-code"
              />

              <v-btn
                @click="confirmBooking()"
                class="reservation-button"
                prepend-icon="mdi-link-variant"
              >
                Link Reservation
              </v-btn>
            </div>
          </template>

          <!-- default to string if not matched to show existing fields that are invalid -->
          <template v-if="col.attribute.startsWith('custom_fields')">
            <v-text-field
              v-if="col.data_type == 'string'"
              type="text"
              :label="col.label"
              v-model="lead.custom_fields[col.field_name]"
              @update:model-value="doChange('custom_fields')"
              autocomplete="off"
              density="compact"
              :error="customFieldError(col)"
              :error-messages="customFieldErrorMessages(col)"
            />

            <v-select
              v-else-if="col.data_type == 'select'"
              :label="col.label"
              v-model="lead.custom_fields[col.field_name]"
              @update:model-value="doChange('custom_fields')"
              :items="
                (col.values || []).map((v) => ({
                  value: v.value,
                  title: v.label,
                }))
              "
              variant="outlined"
              density="compact"
              clearable
              :error="customFieldError(col)"
              :error-messages="customFieldErrorMessages(col)"
            />

            <VuetifyDatePicker
              v-else-if="col.data_type == 'date'"
              :label="col.label"
              density="compact"
              :model-value="dateOnlyValue(col)"
              @update:model-value="setCustomFieldDate(col, $event)"
              :error="customFieldError(col)"
              :error-messages="customFieldErrorMessages(col)"
            />

            <VuetifyDateTimePicker
              v-else-if="col.data_type == 'datetime'"
              :label="col.label"
              density="compact"
              format="M-DD-YYYY hh:mm A"
              :model-value="lead.custom_fields[col.field_name]"
              @update:model-value="setCustomFieldDateTime(col, $event)"
              placeholder="Select date and time"
              autocomplete="off"
              :error="customFieldError(col)"
              :error-messages="customFieldErrorMessages(col)"
            />

            <v-textarea
              v-else-if="col.data_type == 'text'"
              :label="col.label"
              v-model="lead.custom_fields[col.field_name]"
              @update:model-value="doChange('custom_fields')"
              autocomplete="off"
              density="compact"
              rows="3"
              auto-grow
              hide-details="auto"
              :error="customFieldError(col)"
              :error-messages="customFieldErrorMessages(col)"
            />

            <VuetifyNumberInput
              v-else-if="col.data_type == 'number'"
              :label="col.label"
              v-model="lead.custom_fields[col.field_name]"
              @update:model-value="doChange('custom_fields')"
              autocomplete="off"
              density="compact"
              :error="customFieldError(col)"
              :error-messages="customFieldErrorMessages(col)"
            />

            <v-text-field
              v-else
              type="text"
              :label="col.label"
              v-model="lead.custom_fields[col.field_name]"
              @update:model-value="doChange('custom_fields')"
              autocomplete="off"
              density="compact"
              :error="customFieldError(col)"
              :error-messages="customFieldErrorMessages(col)"
            />
          </template>
        </el-col>
      </el-row>

      <v-alert
        v-if="!lead.id"
        type="warning"
        variant="tonal"
        density="compact"
        class="mb-6"
      >
        Complete Required fields first to begin saving notes.
      </v-alert>

      <el-tabs
        v-if="getProfiles?.length"
        v-model="selectedProfile"
        type="card"
        @tab-click="changeProfile"
        class="custom-field-profiles"
      >
        <el-tab-pane v-for="p of getProfiles" :label="p.label" :name="p.id">
          <!-- Dirty copy paste but otherwise I have to link all the emits and valeus -->
          <el-row
            v-for="colGroup in getLeadFields[selectedProfile]"
            style="margin-bottom: 4px"
            :gutter="4"
          >
            <el-col
              v-for="col in colGroup"
              :span="24 / colGroup.length"
              :xs="24 / colGroup.length"
              :sm="24 / colGroup.length"
              :md="(12 / colGroup.length) * 2"
              :lg="(12 / colGroup.length) * 2"
              :xl="(12 / colGroup.length) * 2"
            >
              <template v-if="col.attribute == 'lead_status_id'">
                <lead-status-select
                  v-on:update:leadStatus="setLeadStatus"
                  :initial-id="lead.lead_status_id"
                  :selected-lead-type="lead.lead_type_id ?? 0"
                  style="width: 100%"
                  label="Lead Status"
                  :use-vuetify="true"
                  :error="!lead.lead_status_id"
                  :error-messages="
                    !lead.lead_status_id ? ['Lead Status is required'] : []
                  "
                ></lead-status-select>
                <lost-reason-select
                  v-if="
                    showLostReason &&
                    lead.lost_reason_id &&
                    getLeadSourceDetails(lead.lost_reason_id).length
                  "
                  v-on:update:lostReason="setLostReason"
                  :initialId="lead.lost_reason_id"
                  style="width: 100%"
                  label="Lost Reason"
                  :use-vuetify="true"
                  :error="!lead.lost_reason_id"
                  :error-messages="
                    !lead.lost_reason_id ? ['Lost Reason is required'] : []
                  "
                ></lost-reason-select>
                <lost-reason-detail-select
                  v-if="
                    showLostReason &&
                    lead.lost_reason_id &&
                    getLostReaonDetails(lead.lost_reason_id).length
                  "
                  :lost-reason-id="lead.lost_reason_id"
                  v-on:update:lostReasonDetail="setLostReasonDetail"
                  :initialId="lead.lost_reason_detail_id"
                  style="width: 100%"
                  label="Lost Reason Detail"
                  :error="!lead.lost_reason_detail_id"
                  :error-messages="
                    !lead.lost_reason_detail_id
                      ? ['Lost Reason Detail is required']
                      : []
                  "
                ></lost-reason-detail-select>
              </template>

              <template v-if="col.attribute == 'subject'">
                <!-- Cleaner logic for multi-row subjects -->
                <v-textarea
                  v-if="subjectRows && subjectRows > 1"
                  type="text"
                  label="Lead Subject"
                  v-model="lead.subject"
                  @update:model-value="doChange('subject')"
                  density="compact"
                  autocomplete="off"
                  :rows="subjectRows"
                  :error="
                    getAppConfig.lead.subjectRequired &&
                    (!lead.subject || lead.subject.trim() === '')
                  "
                  :error-messages="
                    getAppConfig.lead.subjectRequired &&
                    (!lead.subject || lead.subject.trim() === '')
                      ? ['Subject is required']
                      : []
                  "
                  hide-details="auto"
                />
                <v-text-field
                  v-else
                  type="text"
                  label="Lead Subject"
                  v-model="lead.subject"
                  @update:model-value="doChange('subject')"
                  density="compact"
                  autocomplete="off"
                  :error="
                    getAppConfig.lead.subjectRequired &&
                    (!lead.subject || lead.subject.trim() === '')
                  "
                  :error-messages="
                    getAppConfig.lead.subjectRequired &&
                    (!lead.subject || lead.subject.trim() === '')
                      ? ['Subject is required']
                      : []
                  "
                  hide-details="auto"
                />
              </template>
              <template
                v-if="
                  col.attribute == 'lead_category_id' &&
                  getLeadCategories?.length > 1
                "
              >
                <lead-category-select
                  @update:leadCategory="resetLeadCategory"
                  :style="{ width: '50%' }"
                  :initialId="leadCategory"
                  :use-vuetify="true"
                ></lead-category-select>
              </template>
              <template
                v-if="
                  col.attribute == 'lead_type_id' && getLeadTypes?.length > 1
                "
              >
                <lead-type-select
                  v-on:update:leadType="setLeadType"
                  v-if="getLeadTypes.length > 1"
                  :initialId="lead.lead_type_id"
                  :allow-all="false"
                  label="Lead Type"
                  :style="{ width: '50%' }"
                  :use-vuetify="true"
                ></lead-type-select>
              </template>
              <template
                v-if="
                  col.attribute == 'contact_id' &&
                  (contactId === undefined || lead.reservation_id == undefined)
                "
              >
                <contact-select
                  :value="lead.contact_id"
                  @update:value="setContact"
                  :size="'small'"
                  :label="'Selected Contact'"
                  :use-vuetify="true"
                  :error="!lead.contact_id"
                  :error-messages="
                    !lead.contact_id ? ['Contact is required'] : []
                  "
                ></contact-select>
              </template>
              <template v-if="col.attribute == 'source_id'">
                <lead-source-select
                  :initial-id="lead.source_id"
                  @update:leadSource="updateLeadSource"
                  label="Lead Source"
                  :style="{
                    width:
                      lead.source_id &&
                      getLeadSourceDetails(lead.source_id).length
                        ? '50%'
                        : '100%',
                  }"
                  :use-vuetify="true"
                  :clearable="false"
                  :error="!lead.source_id"
                  :error-messages="
                    !lead.source_id ? ['Lead Source is required'] : []
                  "
                ></lead-source-select>
                <lead-source-detail-select
                  v-if="
                    lead.source_id &&
                    getLeadSourceDetails(lead.source_id).length
                  "
                  :lead-source-id="lead.source_id"
                  :initial-id="+lead.source_detail_id"
                  @update:leadSourceDetail="updateLeadSourceDetail"
                  label="Lead Source Detail"
                  style="width: 50%"
                  :use-vuetify="true"
                  :clearable="false"
                ></lead-source-detail-select>
              </template>
              <template v-if="col.attribute == 'closing_source_id'">
                <lead-source-select
                  :initial-id="lead.closing_source_id"
                  @update:leadSource="updateClosingLeadSource"
                  label="Closing Lead Source"
                  :style="{
                    width:
                      lead.closing_source_id &&
                      getLeadSourceDetails(lead.closing_source_id).length
                        ? '50%'
                        : '100%',
                  }"
                  :use-vuetify="true"
                  :clearable="false"
                  :error="!lead.closing_source_id"
                  :error-messages="
                    closingSourceRequired && !lead.closing_source_id
                      ? ['Closing Lead Source is required']
                      : []
                  "
                ></lead-source-select>
                <lead-source-detail-select
                  v-if="
                    lead.closing_source_id &&
                    getLeadSourceDetails(lead.closing_source_id).length
                  "
                  :lead-source-id="lead.closing_source_id"
                  :initial-id="+lead.closing_source_detail_id"
                  @update:leadSourceDetail="updateClosingLeadSourceDetail"
                  label="Closing Lead Source Detail"
                  style="width: 50%"
                  :use-vuetify="true"
                  :clearable="false"
                ></lead-source-detail-select>
              </template>
              <VuetifyDateRangePicker
                v-if="col.attribute == 'interest_start_at'"
                label="Reservation Dates"
                v-model="leadDates"
                @change="changeInterestDates"
                format="M-DD-YYYY"
                :background-color="'#304156'"
                :class="colorClass['interest_start_at']"
                :readonly="readOnly['interest_start_at']"
                style="width: '100%'"
                :error="
                  getAppConfig?.lead?.requireDates === true &&
                  (!lead.interest_start_at || !lead.interest_end_at)
                "
                :error-messages="
                  getAppConfig?.lead?.requireDates === true &&
                  (!lead.interest_start_at || !lead.interest_end_at)
                    ? ['Reservation dates are required']
                    : []
                "
              />
              <template v-if="col.attribute == 'user_id'">
                <agent-select
                  :values="[lead.user_id]"
                  @update:values="setAgent"
                  :label="'Select Agent'"
                  :use-vuetify="true"
                  :clearable="false"
                  :error="!lead.user_id"
                  :error-messages="!lead.user_id ? ['Agent Selection'] : []"
                ></agent-select>
              </template>
              <VuetifyDateTimePicker
                v-if="col.attribute == 'followup_at'"
                label="Follow Up"
                format="M-DD-YYYY hh:mm A"
                v-model="lead.followup_at"
                @update:model-value="doChange('followup_at')"
                placeholder="Select date and time"
                :default-time="defaultTime"
                :error="followupRequired && !lead.followup_at"
                :error-messages="
                  followupRequired && !lead.followup_at
                    ? ['Follow up date is required']
                    : []
                "
                autocomplete="off"
              />
              <VuetifyNumberInput
                v-if="col.attribute == 'quantity_1'"
                label="Adults"
                v-model="lead.quantity_1"
                @update:model-value="doChange('quantity_1')"
                autocomplete="off"
                :min="0"
                :step="1"
                :precision="0"
                :class="colorClass['quantity_1']"
              />
              <VuetifyNumberInput
                v-if="col.attribute == 'quantity_2'"
                label="Children"
                v-model="lead.quantity_2"
                @update:model-value="doChange('quantity_2')"
                autocomplete="off"
                :min="0"
                :step="1"
                :precision="0"
                :class="colorClass['quantity_2']"
              />
              <VuetifyNumberInput
                v-if="col.attribute == 'quantity_3'"
                label="Pets"
                v-model="lead.quantity_3"
                @update:model-value="doChange('quantity_3')"
                autocomplete="off"
                :min="0"
                :step="1"
                :precision="0"
                :class="colorClass['quantity_3']"
              />
              <VuetifyCurrencyInput
                v-if="col.attribute == 'estimated_value'"
                label="Estimated Value"
                @change="mutateEstimatedValue()"
                v-model="estimatedValueFloat"
                :class="colorClass['estimated_value']"
                :readonly="readOnly['estimated_value']"
              />
              <template v-if="col.attribute == 'product_code'">
                <unit-type-select
                  :values="[lead.product_code]"
                  @update:values="setOriginUnitType"
                  :label="'Select Unit Type'"
                  :clearable="true"
                  :multi="false"
                ></unit-type-select>
              </template>
              <template v-if="col.attribute == 'origin_product_id'">
                <unit-select
                  :values="[lead.origin_product_id]"
                  @update:values="setOriginUnit"
                  :label="'Select Inquiring Unit'"
                  :clearable="true"
                  :multi="false"
                ></unit-select>
              </template>
              <template v-if="col.attribute == 'final_product_id'">
                <unit-select
                  :values="[lead.final_product_id]"
                  @update:values="setFinalUnit"
                  :label="'Select Booked Unit'"
                  :clearable="true"
                  :multi="false"
                ></unit-select>
              </template>
              <template v-if="col.attribute == 'reservation_id'">
                <div v-if="needsReservation" class="reservation-required-message">
                  This won status requires a linked reservation
                </div>
                <div
                  class="reservation-row"
                  :class="{ 'reservation-required': needsReservation }"
                >
                  <connector-select
                    v-model="connectorId"
                    size="small"
                    select-first-available
                    :use-vuetify="true"
                    class="reservation-connector"
                    :placeholder="'Select Connector'"
                  ></connector-select>

                  <v-text-field
                    type="text"
                    label="Booking Code (from PMS)"
                    v-model="bookingCode"
                    density="compact"
                    autocomplete="off"
                    hide-details="auto"
                    class="reservation-code"
                  />

                  <v-btn
                    @click="confirmBooking()"
                    class="reservation-button"
                    prepend-icon="mdi-link-variant"
                  >
                    Link Reservation
                  </v-btn>
                </div>
              </template>

              <!-- Same set of inputs as the single column layout above -->
              <template v-if="col.attribute.startsWith('custom_fields')">
                <v-text-field
                  v-if="col.data_type == 'string'"
                  type="text"
                  :label="col.label"
                  v-model="lead.custom_fields[col.field_name]"
                  @update:model-value="doChange('custom_fields')"
                  autocomplete="off"
                  density="compact"
                  :error="customFieldError(col)"
                  :error-messages="customFieldErrorMessages(col)"
                />

                <v-select
                  v-else-if="col.data_type == 'select'"
                  :label="col.label"
                  v-model="lead.custom_fields[col.field_name]"
                  @update:model-value="doChange('custom_fields')"
                  :items="
                    (col.values || []).map((v) => ({
                      value: v.value,
                      title: v.label,
                    }))
                  "
                  variant="outlined"
                  density="compact"
                  clearable
                  :error="customFieldError(col)"
                  :error-messages="customFieldErrorMessages(col)"
                />

                <VuetifyDatePicker
                  v-else-if="col.data_type == 'date'"
                  :label="col.label"
                  density="compact"
                  :model-value="dateOnlyValue(col)"
                  @update:model-value="setCustomFieldDate(col, $event)"
                  :error="customFieldError(col)"
                  :error-messages="customFieldErrorMessages(col)"
                />

                <VuetifyDateTimePicker
                  v-else-if="col.data_type == 'datetime'"
                  :label="col.label"
                  density="compact"
                  format="M-DD-YYYY hh:mm A"
                  :model-value="lead.custom_fields[col.field_name]"
                  @update:model-value="setCustomFieldDateTime(col, $event)"
                  placeholder="Select date and time"
                  autocomplete="off"
                  :error="customFieldError(col)"
                  :error-messages="customFieldErrorMessages(col)"
                />

                <v-textarea
                  v-else-if="col.data_type == 'text'"
                  :label="col.label"
                  v-model="lead.custom_fields[col.field_name]"
                  @update:model-value="doChange('custom_fields')"
                  autocomplete="off"
                  density="compact"
                  rows="3"
                  auto-grow
                  hide-details="auto"
                  :error="customFieldError(col)"
                  :error-messages="customFieldErrorMessages(col)"
                />

                <VuetifyNumberInput
                  v-else-if="col.data_type == 'number'"
                  :label="col.label"
                  v-model="lead.custom_fields[col.field_name]"
                  @update:model-value="doChange('custom_fields')"
                  autocomplete="off"
                  density="compact"
                  :error="customFieldError(col)"
                  :error-messages="customFieldErrorMessages(col)"
                />

                <v-text-field
                  v-else
                  type="text"
                  :label="col.label"
                  v-model="lead.custom_fields[col.field_name]"
                  @update:model-value="doChange('custom_fields')"
                  autocomplete="off"
                  density="compact"
                  :error="customFieldError(col)"
                  :error-messages="customFieldErrorMessages(col)"
                />
              </template>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>

      <v-divider class="mx-5 my-5"></v-divider>

      <notes-listing
        v-if="lead.id"
        :key="`${lead.id}-notes`"
        :relationship-type="'lead'"
        :lead-id="lead.id"
        :contact-id="lead.contact_id"
        class="mx-5"
      ></notes-listing>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-title>Tags</v-expansion-panel-title>
          <v-expansion-panel-text>
            <el-checkbox-group v-model="lead.tags" @change="doChange('tags')">
              <div
                v-for="option in filteredTags"
                :key="option.id"
              >
                <el-tag style="margin-bottom: 0.3em" :color="option.color">
                  <el-checkbox :value="option.id">
                    <!-- Same contrast text as the contact profile tags -->
                    <span :style="{ color: contrastTextColor(option.color) }">{{
                      option.label
                    }}</span>
                  </el-checkbox>
                </el-tag>
              </div>
            </el-checkbox-group>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-divider class="mx-2"></v-divider>

      <v-card-actions v-show="!hideButtons" v-if="!livePatch" class="mt-2">
        <v-btn v-if="showClose" @click="close()" variant="text"> Close </v-btn>

        <v-spacer></v-spacer>

        <v-btn v-if="lead.id" @click="copyLink" prepend-icon="mdi-link">
          Copy Link
        </v-btn>

        <v-btn
          v-if="!livePatch"
          :disabled="!dirty"
          @click="reset()"
          variant="outlined"
          class="mx-2"
        >
          Revert Lead
        </v-btn>

        <v-btn
          :disabled="!valid || !dirty"
          @click="save()"
          color="primary"
          v-if="!livePatch"
        >
          Save Lead
        </v-btn>
      </v-card-actions>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toRaw } from 'vue';
import { nestFormFields } from 'src/util/formFields';

import VuetifyDatePicker from 'src/components/UIComponents/Inputs/VuetifyDatePicker.vue';
import VuetifyDateRangePicker from 'src/components/UIComponents/Inputs/VuetifyDateRangePicker.vue';
import VuetifyDateTimePicker from 'src/components/UIComponents/Inputs/VuetifyDateTimePicker.vue';
import VuetifyCurrencyInput from 'src/components/UIComponents/Inputs/VuetifyCurrencyInput.vue';
import VuetifyNumberInput from 'src/components/UIComponents/Inputs/VuetifyNumberInput.vue';

import { processError } from 'src/util/processError.js';
import { toDateOnlyString, toPickerDate } from 'src/util/plainDate';

// import FormField from 'src/components/UIComponents/Inputs/FormField';
import AgentSelect from 'src/components/UIComponents/AgentSelect.vue';
import ContactSelect from 'src/components/UIComponents/ContactSelect.vue';
import TagDisplay from 'src/components/UIComponents/TagDisplay.vue';
import { contrastTextColor } from 'src/util/colorUtils';
import LeadCategorySelect from 'src/components/UIComponents/LeadCategorySelect.vue';
import LeadStatusSelect from 'src/components/UIComponents/LeadStatusSelect.vue';
import LeadSourceSelect from 'src/components/UIComponents/LeadSourceSelect.vue';
import LeadSourceDetailSelect from 'src/components/UIComponents/LeadSourceDetailSelect.vue';
import LostReasonSelect from 'src/components/UIComponents/LostReasonSelect.vue';
import LostReasonDetailSelect from 'src/components/UIComponents/LostReasonDetailSelect.vue';
import LeadTypeSelect from 'src/components/UIComponents/LeadTypeSelect.vue';
import NotesListing from 'src/components/Dashboard/Views/Notes/NotesListing';
import ConnectorSelect from 'src/components/UIComponents/ConnectorSelect';
import UnitSelect from 'src/components/UIComponents/UnitSelect.vue';
import UnitTypeSelect from 'src/components/UIComponents/UnitTypeSelect.vue';

import LeadService from 'src/services/leadService.js';
import ConnectorService from 'src/services/connectorService.js';
import PhoneNumberService from 'src/services/phoneNumberService.js';
import ReservationService from 'src/services/reservationServices.js';

export default {
  name: 'Lead',
  components: {
    AgentSelect,
    ConnectorSelect,
    ContactSelect,
    LeadCategorySelect,
    // FormField,
    LostReasonSelect,
    LostReasonDetailSelect,
    LeadSourceSelect,
    LeadSourceDetailSelect,
    LeadStatusSelect,
    LeadTypeSelect,
    NotesListing,
    TagDisplay,
    // Vuetify
    VuetifyDatePicker,
    VuetifyDateRangePicker,
    VuetifyCurrencyInput,
    VuetifyDateTimePicker,
    VuetifyNumberInput,

    UnitSelect,
    UnitTypeSelect,
  },
  props: {
    leadId: {
      // For editing
      type: Number,
      required: false,
    },
    contactId: {
      type: Number,
      default: () => undefined,
    },
    showClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    sourceNumber: {
      // Set the source from this phone number, if any
      type: String,
      required: false,
    },
    sourceNumberId: {
      type: Number,
      required: false,
    },
    newLeadTypeId: {
      // Set lead type automatically when creating a new lead.
      // An existing lead is never updated
      type: Number,
      required: false,
    },
    livePatch: {
      // Save the lead as as soon as possible.
      // Once the lead is saved, all new changes will be live patched to the server
      type: Boolean,
      required: false,
      default: false,
    },
    hideButtons: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    leadId() {
      this.loadLead();
    },
    contactId(id) {
      this.lead.contact_id = id;
      this.doChange('contact_id');
    },
    sourceNumber() {
      this.setSource();
    },
    sourceNumberId() {
      this.setSource();
    },
  },
  computed: {
    ...mapGetters('appConfig', ['getAppConfig']),
    ...mapGetters('auth', ['getLoginAccount', 'getGlobalBrandIds']),
    ...mapGetters('leadCategory', ['getLeadCategories']),
    ...mapGetters('formFieldProfiles', ['getFormFieldProfiles']),
    ...mapGetters('leadSource', ['getLeadSources', 'getLeadSourceDetails']),
    ...mapGetters('leadStatus', ['getLeadStatuses']),
    // Highlights Link Reservation until the won status has one
    needsReservation() {
      return this.reservationRequired && !this.lead.reservation_id;
    },
    ...mapGetters('lostReason', ['getLostReasonDetails']),
    ...mapGetters('leadType', ['getLeadTypes']),
    ...mapGetters('phoneNumbers', ['getPhoneNumbers']),
    ...mapGetters('customFields', ['getLeadCustomFields']),
    ...mapGetters('tags', ['getTags']),
    filteredTags() {
      const activeTags = this.getTags.filter((t) => t.active != false);
      if (!this.getGlobalBrandIds) {
        return activeTags;
      }
      return activeTags.filter((t) => {
        if (!t.brand_ids || t.brand_ids.length === 0) {
          return true;
        }
        return t.brand_ids.some((id) => this.getGlobalBrandIds.includes(id));
      });
    },
    rules() {
      const subRequired =
        this.getAppConfig &&
        this.getAppConfig.lead &&
        this.getAppConfig.lead.subjectRequired != undefined
          ? this.getAppConfig.lead.subjectRequired
          : false;
      const rules = {
        contact_id: [{ required: true, trigger: 'change' }],
        lead_status_id: [{ required: true }],
        source_id: [{ required: true, trigger: 'change' }],
        closing_source_id: [
          { required: this.closingSourceRequired, trigger: 'change' },
        ],
        subject: [{ required: subRequired, trigger: 'change' }],
        user_id: [{ required: true, trigger: 'change' }],
        followup_at: [{ required: this.followupRequired, trigger: 'change' }],
      };
      for (const c of this.getCustomFields) {
        if (c.is_required) {
          rules['custom_fields.' + c.field_name] = [
            { required: true, trigger: 'change' },
          ];
        }
      }
      return rules;
    },
    subjectRows() {
      return this.getAppConfig &&
        this.getAppConfig.lead &&
        this.getAppConfig.lead.subjectRows
        ? this.getAppConfig.lead.subjectRows
        : 1;
    },
    getDefaultLeadType() {
      const lt = this.getLeadTypes.find((t) => t.is_default === true);
      return lt ? lt.id : undefined;
    },
    getProfiles() {
      // Make this only fire if the lead_type_id is set in the elements
      if (!this.getLeadTypes || !this.lead?.lead_type_id) {
        return [];
      }
      const leadType = this.getLeadTypes.find(
        (lt) => lt.id == this.lead.lead_type_id
      );

      if (!leadType || !leadType.leadTypeProfiles) {
        console.warn(
          `Lead type with ID ${this.lead.lead_type_id} not found or has no profiles`
        );
        return [];
      }

      const profileIds = leadType.leadTypeProfiles.map((p) => p.profile_id);
      return this.getFormFieldProfiles.filter((p) => profileIds.includes(p.id));
    },
    getCustomFields() {
      const custom_fields = [];
      // should make the component load dependant on this being set.
      // ie v-if getLeadTypes.... is not undefined
      if (!this.getLeadTypes) {
        return custom_fields;
      }
      const leadType = this.getLeadTypes.find(
        (lt) => lt.id == this.lead.lead_type_id
      );
      // This will happen on first load before lead type is selected
      if (!leadType) {
        return custom_fields;
      }
      const profileIds = leadType.leadTypeProfiles.map((p) => p.profile_id);
      this.getLeadCustomFields.map((cf) => {
        if (cf.profile_id == null || profileIds.includes(cf.profile_id)) {
          custom_fields.push({
            ...cf, // augment custom fields with needed column attributes
            display_order: cf.display_order ?? 10,
            attribute: 'custom_fields.' + cf.field_name,
            label: cf.label,
            // required_types limits is_required to those lead types.
            // Empty/null required_types means required for every lead type.
            is_required:
              !!cf.is_required && this.isRequiredForLeadType(cf.required_types),
          });
        }
      });
      return custom_fields;
    },
    getLeadFields() {
      // Nest objects ordered by profile_id -> display_order
      return nestFormFields(
        this.getAppConfig?.lead?.leadFormFields,
        this.getCustomFields
      );
    },
  },
  data() {
    return {
      saveProm: undefined,
      savePromResolve: undefined, // linked to saveProm above
      selectedProfile: undefined,
      estimatedValueFloat: 0,
      leadCategory: undefined,
      lsRelatedType: undefined,
      lsdRelatedType: undefined,
      closingSourceRequired: false,
      closingLsRelatedType: undefined,
      closingLsdRelatedType: undefined,
      bookingCode: undefined,
      leadDates: [undefined, undefined],
      colorClass: {
        interest_start_at: undefined,
        interest_end_at: undefined,
        estimated_value: undefined,
        quantity_1: undefined,
        quantity_2: undefined,
        quantity_3: undefined,
      },
      readOnly: {
        interest_start_at: undefined,
        interest_end_at: undefined,
        estimated_value: undefined,
      },
      lead: {
        id: undefined,
        subject: undefined,
        contact_id: undefined,
        lead_status_id: undefined,
        user_id: undefined,
        source_id: undefined,
        source_related_id: undefined,
        source_detail_id: undefined,
        source_detail_related_id: undefined,
        closing_source_id: undefined,
        closing_source_related_id: undefined,
        closing_source_detail_id: undefined,
        closing_source_detail_related_id: undefined,
        interest_start_at: undefined,
        interest_end_at: undefined,
        followup_at: undefined,
        quantity_1: undefined,
        quantity_2: undefined,
        quantity_3: undefined,
        estimated_value: undefined,
        product_code: undefined,
        origin_product_id: undefined,
        final_product_id: undefined,
        reservation_id: undefined,
        custom_fields: {},
        tags: [],
      },
      savedLead: {
        id: undefined,
        subject: undefined,
        contact_id: undefined,
        lead_status_id: undefined,
        user_id: undefined,
        source_id: undefined,
        source_related_id: undefined,
        source_detail_id: undefined,
        source_detail_related_id: undefined,
        closing_source_id: undefined,
        closing_source_related_id: undefined,
        closing_source_detail_id: undefined,
        closing_source_detail_related_id: undefined,
        interest_start_at: undefined,
        interest_end_at: undefined,
        followup_at: undefined,
        quantity_1: undefined,
        quantity_2: undefined,
        quantity_3: undefined,
        estimated_value: undefined,
        product_code: undefined,
        origin_product_id: undefined,
        final_product_id: undefined,
        reservation_id: undefined,
        custom_fields: {},
        tags: [],
      },
      dirty: false,
      valid: false,
      // Lock values after input, this needs to be an option at some point.
      lock: true,
      canPatch: false, // Prevents patch before the lead is valid or saved
      connectorId: undefined,
      showLostReason: undefined,
      followupRequired: undefined,
      // Won status that needs a linked reservation
      reservationRequired: false,
      defaultTime: undefined,
    };
  },
  async beforeMount() {
    const now = new Date();
    now.setHours(12);
    this.defaultTime = now;
    await this.loadLead();
    this.selectedProfile = this.getProfiles.find((f) => f.is_default)?.id;
    if (this.contactId) {
      this.lead.contact_id = this.contactId;
    }
  },
  methods: {
    contrastTextColor,
    // required_types is a comma separated list of lead type ids that a
    // required custom field applies to. When empty it applies to all of them.
    isRequiredForLeadType(requiredTypes) {
      if (requiredTypes == undefined || requiredTypes === '') {
        return true;
      }
      const ids = (
        Array.isArray(requiredTypes)
          ? requiredTypes
          : String(requiredTypes).split(',')
      )
        .map((id) => String(id).trim())
        .filter((id) => id !== '');

      if (!ids.length) {
        return true;
      }
      return ids.some((id) => id == this.lead?.lead_type_id);
    },
    isCustomFieldEmpty(col) {
      const value = this.lead?.custom_fields?.[col.field_name];
      return value == undefined || value === '';
    },
    // getCustomFields has already resolved is_required against required_types
    customFieldError(col) {
      return !!col.is_required && this.isCustomFieldEmpty(col);
    },
    customFieldErrorMessages(col) {
      return this.customFieldError(col) ? [`${col.label} is required`] : [];
    },
    changeProfile() {
      // anything we need
    },
    async loadLead() {
      this.savedLead = {
        id: undefined,
        subject: undefined,
        contact_id: undefined,
        lead_status_id: undefined,
        lead_type_id: undefined,
        user_id: undefined,
        source_id: undefined,
        source_related_id: undefined,
        source_detail_id: undefined,
        source_detail_related_id: undefined,
        closing_source_id: undefined,
        closing_source_related_id: undefined,
        closing_source_detail_id: undefined,
        closing_source_detail_related_id: undefined,
        interest_start_at: undefined,
        interest_end_at: undefined,
        followup_at: undefined,
        quantity_1: undefined,
        quantity_2: undefined,
        quantity_3: undefined,
        estimated_value: undefined,
        product_code: undefined,
        origin_product_id: undefined,
        final_product_id: undefined,
        reservation_id: undefined,
        lost_reason_id: undefined,
        lost_reason_detail_id: undefined,
        custom_fields: {},
        tags: [],
      };

      // Reset to nothing in case anything errors
      this.lead = {
        id: undefined,
        subject: undefined,
        contact_id: undefined,
        lead_status_id: undefined,
        lead_type_id: undefined,
        user_id: undefined,
        source_id: undefined,
        source_related_id: undefined,
        source_detail_id: undefined,
        source_detail_related_id: undefined,
        closing_source_id: undefined,
        closing_source_related_id: undefined,
        closing_source_detail_id: undefined,
        closing_source_detail_related_id: undefined,
        interest_start_at: undefined,
        interest_end_at: undefined,
        followup_at: undefined,
        quantity_1: undefined,
        quantity_2: undefined,
        quantity_3: undefined,
        estimated_value: undefined,
        product_code: undefined,
        origin_product_id: undefined,
        final_product_id: undefined,
        reservation_id: undefined,
        lost_reason_id: undefined,
        lost_reason_detail_id: undefined,
        custom_fields: {},
        tags: [],
      };

      if (this.leadId) {
        const result = await LeadService.fetchById(this.leadId);
        if (!result) {
          console.error('Lead not found by id');
          this.valid = false;
          this.$emit('update:valid', this.valid);
          // TODO: pop this to the user
          return;
        }
        const lead = result.data;
        this.leadDates[0] = lead.interest_start_at;
        this.leadDates[1] = lead.interest_end_at;
        // Only set on initial load
        this.connectorId = lead.connector_id;
        delete this.lead.connector_id;

        // Set category if lead_type has one
        if (
          lead.lead_type_id &&
          this.getLeadTypes &&
          this.getLeadTypes.length > 0
        ) {
          const lt = this.getLeadTypes.find((lt) => lt.id == lead.lead_type_id);
          if (lt && lt.lead_category_id !== undefined) {
            this.leadCategory = lt.lead_category_id;
          } else {
            console.warn(`Lead type with ID ${lead.lead_type_id} not found`);
          }
        }
        this.lead.id = this.leadId;
        this.lead.subject = lead.subject ? lead.subject : undefined;
        this.lead.contact_id = lead.contact_id ? lead.contact_id : undefined;
        this.lead.lead_status_id = lead.lead_status_id;
        this.lead.lead_type_id = lead.lead_type_id;
        this.lead.user_id = lead.user_id;
        this.lead.source_id = lead.source_id;
        this.lead.source_related_id = lead.source_related_id;
        this.lead.source_detail_id = lead.source_detail_id;
        this.lead.source_detail_related_id = lead.source_detail_related_id;
        this.lead.closing_source_id = lead.closing_source_id;
        this.lead.closing_source_related_id = lead.closing_source_related_id;
        this.lead.closing_source_detail_id = lead.closing_source_detail_id;
        this.lead.closing_source_detail_related_id =
          lead.closing_source_detail_related_id;
        this.lead.interest_start_at = lead.interest_start_at;
        this.lead.interest_end_at = lead.interest_end_at;
        this.lead.followup_at = lead.followup_at;
        this.lead.quantity_1 = lead.quantity_1 ? lead.quantity_1 : undefined;
        this.lead.quantity_2 = lead.quantity_2 ? lead.quantity_2 : undefined;
        this.lead.quantity_3 = lead.quantity_3 ? lead.quantity_3 : undefined;
        this.lead.estimated_value = lead.estimated_value
          ? lead.estimated_value
          : 0;
        this.estimatedValueFloat = Number(
          (lead.estimated_value / 100).toFixed(2)
        );
        this.lead.product_code = lead.product_code;
        this.lead.origin_product_id = lead.origin_product_id;
        this.lead.final_product_id = lead.final_product_id;
        this.lead.reservation_id = lead.reservation_id;
        this.lead.lost_reason_id = lead.lost_reason_id;
        this.lead.lost_reason_detail_id = lead.lost_reason_detail_id;
        this.lead.custom_fields = lead.custom_fields ?? {};
        this.lead.tags = lead.tags ?? [];

        // Set the source related as needed
        if (this.lead.source_id) {
          const ls = this.getLeadSources.find(
            (ls) => ls.id == this.lead.source_id
          );
          this.lsRelatedType = ls?.related_type;
        } else {
          this.lsRelatedType = undefined;
        }

        if (this.lead.source_detail_id) {
          const lsd = this.getLeadSourceDetails(this.lead.source_id).find(
            (lsd) => lsd.id == this.lead.source_detail_id
          );
          this.lsdRelatedType = lsd?.related_type;
        } else {
          this.lsdRelatedType = undefined;
        }

        if (this.lead.closing_source_id) {
          const cls = this.getLeadSources.find(
            (ls) => ls.id == this.lead.closing_source_id
          );
          this.closingLsRelatedType = cls?.related_type;
        } else {
          this.closingLsRelatedType = undefined;
        }

        if (this.lead.closing_source_detail_id) {
          const clsd = this.getLeadSourceDetails(
            this.lead.closing_source_id
          ).find((lsd) => lsd.id == this.lead.closing_source_detail_id);
          this.closingLsdRelatedType = clsd?.related_type;
        } else {
          this.closingLsdRelatedType = undefined;
        }

        // set the lost reason display
        const curStatus = this.getLeadStatuses.find(
          (l) => l.id == lead.lead_status_id
        );
        this.showLostReason = !curStatus ? false : curStatus.is_lost;
        this.followupRequired = curStatus ? curStatus.is_followup : false;
        this.reservationRequired = this.requiresReservation(curStatus);
        // Eventually make this required, perhaps with config so it does not change
        // workflows for current users
        // this.closingSourceRequired = !curStatus ? false : curStatus.is_won;

        // Set saved lead for reverting later
        this.savedLead.id = lead.id;
        this.savedLead.subject = lead.subject;
        this.savedLead.contact_id = lead.contact_id;
        this.savedLead.lead_status_id = lead.lead_status_id;
        this.savedLead.lead_type_id = lead.lead_type_id;
        this.savedLead.user_id = lead.user_id;
        this.savedLead.source_id = lead.source_id;
        this.savedLead.source_related_id = lead.source_related_id;
        this.savedLead.source_detail_id = lead.source_detail_id;
        this.savedLead.source_detail_related_id = lead.source_detail_related_id;
        this.savedLead.closing_source_id = lead.closing_source_id;
        this.savedLead.closing_source_related_id =
          lead.closing_source_related_id;
        this.savedLead.closing_source_detail_id = lead.closing_source_detail_id;
        this.savedLead.closing_source_detail_related_id =
          lead.closing_source_detail_related_id;
        this.savedLead.interest_start_at = lead.interest_start_at;
        this.savedLead.interest_end_at = lead.interest_end_at;
        this.savedLead.followup_at = lead.followup_at;
        this.savedLead.quantity_1 = lead.quantity_1
          ? lead.quantity_1
          : undefined;
        this.savedLead.quantity_2 = lead.quantity_2
          ? lead.quantity_2
          : undefined;
        this.savedLead.quantity_3 = lead.quantity_3
          ? lead.quantity_3
          : undefined;
        this.savedLead.estimated_value = lead.estimated_value;
        this.savedLead.product_code = lead.product_code;
        this.savedLead.origin_product_id = lead.origin_product_id;
        this.savedLead.final_product_id = lead.final_product_id;
        this.savedLead.reservation_id = lead.reservation_id;
        // no nesting allowed
        this.savedLead.custom_fields = Object.assign({}, lead.custom_fields);
        this.savedLead.tags = lead.tags;

        // Try to pull reservation
        if (lead && lead.reservation_id) {
          const reservation = await ReservationService.fetchReservationsById(
            lead.reservation_id
          );
          this.bookingCode = reservation.data.reservation_number;
          // todo: could possible augment the adult/child or additional props if necessary
        }

        // Assume the data from the DB is pristine
        this.dirty = false;
        this.valid = this.isValid();
      } else {
        // On new leads we set the type from callResult if provided
        // Otherwise we try the default
        this.lead.lead_type_id = this.newLeadTypeId ?? this.getDefaultLeadType;
      }

      // Which takes precedence if contact is different from saved?
      if (this.contactId) {
        const savedContact = this.lead.contact_id;
        this.lead.contact_id = this.contactId;
        this.savedLead.contact_id = this.contactId;
        if (savedContact != this.contactId) {
          this.dirty = true;
          this.valid = false;
        }
        // This will update the dirty/valid;
        if (this.lead.id && this.livePatch && savedContact != this.contactId) {
          await this.save('contact_id');
        }
      }
      await this.setSource();
      try {
        // Populate Agent Id on Load
        if (!this.lead.user_id && this.getLoginAccount.userId) {
          const savedAgent = this.lead.user_id;
          this.lead.user_id = this.getLoginAccount.userId;
          this.savedLead.user_id = this.getLoginAccount.userId;
          // Save immediately if you can
          if (savedAgent != this.lead.user_id) {
            this.dirty = true;
            this.valid = false;
          }
          if (
            this.lead.id &&
            this.livePatch &&
            savedAgent != this.getLoginAccount.userId
          ) {
            await this.save('user_id');
          }
        }
      } catch (e) {
        console.error("Can't auto select agent id: " + e);
      }

      // Only really needed if we did not save and there are differences
      // Forces a save to get all the updates correct
      this.$emit('update:dirty', this.dirty);
      this.$emit('update:valid', this.valid);
      // this.$emit('update:lead', this.savedLead);
    },
    async setSource() {
      // Dont set a source if existing
      if (this.lead.source_id) {
        return;
      }
      if (!this.sourceNumber && !this.sourceNumberId) {
        // nothing to do if neither is set
        return;
      }
      let number_;
      if (this.sourceNumber && this.sourceNumber.length > 0) {
        const p = await PhoneNumberService.fetchByNumber(this.sourceNumber);
        if (!p || !p.data) {
          console.log('lead source not found for number', this.sourceNumber);
          return;
        }
        // Dont unset if no lead source is not assigned to number
        if (!p.data.lead_source_id) {
          return;
        }
        number_ = p.data;
      }
      // Preference on id vs number string or both?
      if (this.sourceNumberId) {
        number_ = this.getPhoneNumbers.find((p) => p.id == this.sourceNumberId);
      }
      if (number_) {
        const savedSource = this.lead.source_id;
        this.lead.source_id = number_.lead_source_id;
        this.lead.source_detail_id = number_.lead_source_detail_id;
        this.savedLead.source_id = number_.lead_source_id;
        this.savedLead.source_detail_id = number_.lead_source_detail_id;
        // Save any discrepancy immediately, if existing lead on patch mode
        if (savedSource != number_.lead_source_id) {
          this.dirty = true;
          this.valid = false;
        }
        if (
          this.lead.id &&
          this.livePatch &&
          savedSource != number_.lead_source_id
        ) {
          await this.save('source_id');
          await this.save('source_detail_id');
        }
      }
    },
    async save(field) {
      // Validate guard clause
      if (!this.isValid()) {
        return false;
      }
      // This needs to be a singleton to prevent incorrect state patch
      // saves.  They dont need to be serialized for patch but the entire
      // patch must be completed as a single unit of work otherwise parital
      // commits can happen overwriting or deleting other data.
      let result;
      while (this.saveProm) {
        await this.saveProm;
        // A new promise might be assigned before this one resolved.
        // So check in a loop and only proceed when no lock
      }
      this.saveProm = new Promise((resolve, reject) => {
        this.savePromResolve = resolve;
      });
      // have we saved this before or loaded an existing?
      if (this.lead && this.lead.id) {
        let patch = {};
        // On live patch we only need to save the individual field per change
        // If there are multiple patches in series they will all block at the
        // Await and then start patching after they complete.
        // Sends more over the network initially but safe in the long run.
        if (this.livePatch && this.canPatch) {
          if (field == 'custom_fields') {
            patch['custom_fields'] = {};
            Object.keys(this.lead.custom_fields).forEach((k) => {
              if (
                this.getCustomFields.find((cf) => cf.field_name == k) !==
                undefined
              ) {
                patch['custom_fields'][k] = this.lead.custom_fields[k];
              }
            });
          } else {
            // TODO:
            // We should reset custom fields if the lead type id changes
            // As the body will most likely be invalid
            patch[field] = this.lead[field];
          }
          // Save contact Id because you cant 'see' that one
          patch['contact_id'] = this.lead.contact_id;
          // Only really needed if we did not save and there are differences
        } else {
          const patchCustomFields = {};
          Object.keys(this.lead.custom_fields).forEach((k) => {
            if (this.getCustomFields.find((cf) => cf.field_name == k)) {
              patchCustomFields[k] = this.lead.custom_fields[k];
            }
          });

          patch = {
            subject: this.lead.subject,
            contact_id: this.lead.contact_id,
            lead_status_id: this.lead.lead_status_id,
            lead_type_id: this.lead.lead_type_id,
            user_id: this.lead.user_id,
            source_id: this.lead.source_id,
            source_related_id: this.lead.source_related_id,
            source_detail_id: this.lead.source_detail_id,
            source_detail_related_id: this.lead.source_detail_related_id,
            closing_source_id: this.lead.closing_source_id,
            closing_source_related_id: this.lead.closing_source_related_id,
            closing_source_detail_id: this.lead.closing_source_detail_id,
            closing_source_detail_related_id:
              this.lead.closing_source_detail_related_id,
            interest_start_at: this.lead.interest_start_at,
            interest_end_at: this.lead.interest_end_at,
            followup_at: this.lead.followup_at,
            quantity_1: this.lead.quantity_1,
            quantity_2: this.lead.quantity_2,
            quantity_3: this.lead.quantity_3,
            estimated_value: this.lead.estimated_value,
            product_code: this.lead.product_code,
            origin_product_id: this.lead.origin_product_id,
            final_product_id: this.lead.final_product_id,
            reservation_id: this.lead.reservation_id,
            lost_reason_id: this.lead.lost_reason_id,
            lost_reason_detail_id: this.lead.lost_reason_detail_id,
            custom_fields: patchCustomFields, // Must be the full set
            tags: toRaw(this.lead.tags), // Must be the full set
          };
        }

        // Lead Subject is a frontend only requirement so its easily faked
        // Backend still requires a subject but empty string is valid
        if (
          patch.subject == undefined &&
          this.getAppConfig &&
          this.getAppConfig.lead &&
          this.getAppConfig.lead.subjectRequired != undefined &&
          this.getAppConfig.lead.subjectRequired == false
        ) {
          patch.subject = ''; // default to empty string for now
        }

        try {
          // Wait for other pending operations
          result = await LeadService.updateLead(this.lead.id, patch);
          this.canPatch = true; // Once it saved successfully we can patch
        } catch (e) {
          const errMsg = processError(e.response);

          this.$message({
            type: 'error',
            message: 'Error saving lead: ' + errMsg,
            showClose: true,
          });
          // Errored out; release the lock
          this.saveProm = undefined;
          this.savePromResolve();
          this.savePromResolve = undefined;
          return false;
        }
      } else {
        try {
          // Lead Subject is a frontend only requirement so its easily faked
          // Backend still requires a subject but empty string is valid
          if (
            this.lead.subject == undefined &&
            this.getAppConfig &&
            this.getAppConfig.lead &&
            this.getAppConfig.lead.subjectRequired != undefined &&
            this.getAppConfig.lead.subjectRequired == false
          ) {
            this.lead.subject = ''; // default to empty string for now
          }
          result = await LeadService.createLead({
            subject: this.lead.subject,
            contact_id: this.lead.contact_id,
            lead_status_id: this.lead.lead_status_id,
            lead_type_id: this.lead.lead_type_id,
            user_id: this.lead.user_id,
            source_id: this.lead.source_id,
            source_related_id: this.lead.source_related_id,
            source_detail_id: this.lead.source_detail_id,
            source_detail_related_id: this.lead.source_detail_related_id,
            closing_source_id: this.lead.closing_source_id,
            closing_source_related_id: this.lead.closing_source_related_id,
            closing_source_detail_id: this.lead.closing_source_detail_id,
            closing_source_detail_related_id:
              this.lead.closing_source_detail_related_id,
            interest_start_at: this.lead.interest_start_at,
            interest_end_at: this.lead.interest_end_at,
            followup_at: this.lead.followup_at,
            quantity_1: this.lead.quantity_1,
            quantity_2: this.lead.quantity_2,
            quantity_3: this.lead.quantity_3,
            estimated_value: this.lead.estimated_value,
            product_code: this.lead.product_code,
            origin_product_id: this.lead.origin_product_id,
            final_product_id: this.lead.final_product_id,
            reservation_id: this.lead.reservation_id,
            lost_reason_id: this.lead.lost_reason_id,
            lost_reason_detail_id: this.lead.lost_reason_detail_id,
            custom_fields: this.lead.custom_fields,
            tags: this.lead.tags,
          });
          this.canPatch = true;
        } catch (e) {
          this.$message({
            type: 'error',
            message: 'Error saving lead: ' + processError(e.response ?? e),
            showClose: true,
          });
          // Errored out; release the lock
          this.saveProm = undefined;
          this.savePromResolve();
          this.savePromResolve = undefined;
          return false;
        }
      }

      // let the user know
      if (!this.livePatch) {
        this.$message({
          message: 'Success saving lead',
          type: 'success',
          showClose: true,
        });
      }

      this.savedLead = Object.assign({}, this.lead);
      // No nested fields.
      this.savedLead.custom_fields = Object.assign({}, this.lead.custom_fields);
      // TODO: validate here too
      this.savedLead.id = result.data.id;
      this.lead.id = result.data.id;
      this.dirty = false;
      this.valid = true;
      this.$emit('update:dirty', false);
      this.$emit('update:valid', true);
      this.$emit('update:lead', this.savedLead);
      this.saveProm = undefined;
      // Prevent resolve from contexting immediately to other event
      const tmp = this.savePromResolve;
      this.savePromResolve = undefined;
      tmp();
    },
    requiresReservation(leadStatus) {
      return !!(leadStatus?.is_won && leadStatus?.require_reservation);
    },
    setLeadStatus(leadStatus) {
      // Not sure if I like passing the whole object back or just the id,
      // This way I can have the values associated with it like is_won ,etc without a lookup
      this.lead.lead_status_id = leadStatus.id;
      this.lead.lost_reason_id = undefined;
      this.lead.lost_reason_detail_id = undefined;
      this.showLostReason = leadStatus.is_lost;
      this.followupRequired = leadStatus.is_followup;
      this.reservationRequired = this.requiresReservation(leadStatus);
      // this.closingSourceRequired = leadStatus.is_won;
      // Set all the state before sending other changes
      this.doChange('lead_status_id');
      this.doChange('lost_reason_detail_id');
      this.doChange('lost_reason_id');
    },
    setLostReason(lostReason) {
      this.lead.lost_reason_id = lostReason?.id;
      this.lead.lost_reason_detail_id = null;
      this.doChange('lost_reason_detail_id');
      this.doChange('lost_reason_id');
    },
    setLostReasonDetail(lostReasonDetail) {
      this.lead.lost_reason_detail_id = lostReasonDetail?.id;
      this.doChange('lost_reason_detail_id');
    },
    resetLeadCategory(cat) {
      this.dirty = true;
      this.leadCategory = cat?.id;
      this.lead.lead_status_id = undefined;
      this.lead.lead_type_id = undefined;
    },
    setLeadType(ld) {
      if (ld == undefined) {
        this.lead.lead_type_id = null;
      } else {
        this.lead.lead_type_id = ld.id;
      }
      this.doChange('lead_type_id');
    },
    setOriginUnitType(values) {
      // unset comes in as undefined but we need null to unset
      this.lead.product_code = values.length ? values[0] ?? null : null;
      this.doChange('product_code');
    },
    setOriginUnit(values) {
      // unset comes in as undefined but we need null to unset
      this.lead.origin_product_id = values.length ? values[0] ?? null : null;
      this.doChange('origin_product_id');
    },
    setFinalUnit(values) {
      // unset comes in as undefined but we need null to unset
      this.lead.final_product_id = values.length ? values[0] ?? null : null;
      this.doChange('final_product_id');
    },
    mutateEstimatedValue() {
      this.lead.estimated_value = parseInt(this.estimatedValueFloat * 100, 10);
      this.doChange('estimated_value');
    },
    doChange(field) {
      // Only emit on the change, we will update later
      if (!this.dirty) {
        this.$emit('update:dirty', true);
      }
      this.dirty = true;
      const tmp = this.isValid();
      if (this.valid != tmp) {
        this.$emit('update:valid', tmp);
      }
      this.valid = tmp;
      if (this.livePatch && this.isValid()) {
        this.save(field);
      }
    },

    // Custom fields are always a string on input/output.
    // THese are replicated in contact custom fields too
    // Eventually put this on one spot
    setCustomField(col, value) {
      this.lead.custom_fields[col.field_name] = value;
      this.doChange('custom_fields');
    },

    dateOnlyValue(col) {
      return toPickerDate(this.lead.custom_fields[col.field_name]);
    },

    setCustomFieldDate(col, value) {
      this.setCustomField(col, toDateOnlyString(value));
    },

    setCustomFieldDateTime(col, value) {
      if (typeof value == 'string' && value.length) {
        this.setCustomField(col, value);
        return;
      }
      const picked = this.pickedDate(value);
      this.setCustomField(col, picked ? picked.toISOString() : null);
    },

    pickedDate(value) {
      if (!value) {
        return undefined;
      }
      const picked = value instanceof Date ? value : new Date(value);
      return isNaN(picked.getTime()) ? undefined : picked;
    },
    // End of Lead custom fields replication

    changeInterestDates(dates) {
      this.leadDates[0] = dates[0];
      this.leadDates[1] = dates[1];
      // Need null to unset dates
      this.lead.interest_start_at = dates[0] ? dates[0] : null;
      this.lead.interest_end_at = dates[1] ? dates[1] : null;
      this.doChange('interest_start_at');
      this.doChange('interest_end_at');
    },
    /*
    changeInterestStart(prop) {
      this.doChange('interest_start_at');
      // FIXME: confirm this is working.
      if (this.lead.interest_start_at == undefined) {
        return;
      }
      if (this.lead.interest_end_at == undefined ||
        this.lead.interest_end_at <= this.lead.interest_start_at
      ) {
        this.lead.interest_end_at = new Date(
          this.lead.interest_start_at.getTime() + 86400 * 1000
        );
        this.doChange('interest_end_at');
      }
    },
    */
    reset() {
      this.lead = Object.assign({}, this.savedLead);
      this.leadDates[0] = this.lead.inserest_start_at;
      this.leadDates[1] = this.lead.interest_end_at;
      // Set category if lead_type has one
      if (
        this.lead.lead_type_id &&
        this.getLeadTypes &&
        this.getLeadTypes.length > 0
      ) {
        const lt = this.getLeadTypes.find(
          (lt) => lt.id == this.lead.lead_type_id
        );
        if (lt && lt.lead_category_id !== undefined) {
          this.leadCategory = lt.lead_category_id;
        } else {
          console.warn(
            `Lead type with ID ${this.lead.lead_type_id} not found or has no category`
          );
          // Set a safe default or leave undefined
          this.leadCategory = undefined;
        }
      }
      this.lead.custom_fields = Object.assign({}, this.savedLead.custom_fields);

      if (this.contactId) {
        this.lead.contact_id = this.contactId;
      }

      this.dirty = false;
      this.valid = this.isValid();
      this.$emit('update:dirty', false);
      this.$emit('update:valid', this.valid);
    },
    isValid() {
      if (this.showLostReason && !this.lead.lost_reason_id) {
        this.canPatch = false;
        return false;
      }
      // This is a frontend only requirement so its easily faked
      // Backend still requires a subject but empty string is valid
      if (
        this.getAppConfig &&
        this.getAppConfig.lead &&
        this.getAppConfig.lead.subjectRequired != undefined &&
        this.getAppConfig.lead.subjectRequired &&
        !this.lead.subject
      ) {
        this.canPatch = false;
        return false;
      }
      // Also a FE only required at the moment
      if (this.followupRequired && !this.lead.followup_at) {
        this.canPatch = false;
        return false;
      }
      // The API 422s this so hold the save until a reservation is linked
      if (this.needsReservation) {
        this.canPatch = false;
        return false;
      }

      if (
        this.lead.lost_reason_id &&
        this.getLostReasonDetails[this.lead.lost_reason_id]?.length &&
        !this.lead.lost_reason_detail_id
      ) {
        // Can patch?? but not valid
        return false;
      }

      // This can get expensive if you have lots of custom fields
      // TOOD: Make this a computed method at the very least
      for (const f of this.getCustomFields.filter((f) => f.is_required)) {
        if (this.isCustomFieldEmpty(f)) {
          this.canPatch = false;
          return false;
        }
      }
      if (this.closingSourceRequired && !this.lead.closing_source_id) {
        this.canPatch = false;
        return false;
      }

      // Require interest dates if configured
      if (
        this.getAppConfig?.lead?.requireDates === true &&
        (!this.lead.interest_start_at || !this.lead.interest_end_at)
      ) {
        this.canPatch = false;
        return false;
      }

      if (
        this.lead.contact_id &&
        this.lead.source_id &&
        this.lead.lead_status_id &&
        this.lead.user_id
      ) {
        return true;
      }

      // Prevent patch when not valid
      this.canPatch = false;
      return false;
    },
    setAgent(values) {
      if (values.length) {
        this.lead.user_id = values[0];
      } else {
        // TODO: we don't allow un-setting?
        this.lead.user_id = undefined;
      }
      this.doChange('user_id');
    },
    close() {
      this.$emit('close');
    },
    async confirmBooking() {
      let status = undefined;
      try {
        status = await ConnectorService.getRealtimeBooking(
          this.connectorId,
          this.lead.contact_id ?? 0,
          this.bookingCode
        );
      } catch (e) {
        if (e.response == undefined) {
          // Some non request error
          console.error('Unhandled error linking reservation', e);
          this.$message({
            type: 'error',
            message: 'Unexpected error processing reservation data: ' + e,
            showClose: true,
          });
          return false;
        }
        // Mostly care about existing contacts with different ids
        if (e.response.status == 409 && e.response.data.contact_id) {
          this.$confirm(
            'Reservation is saved to another contact. Save this lead to the existing contact?',
            'Reservation Conflict',
            {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
            }
          )
            .then(async () => {
              // If the reservation exists on a different contact, lets try
              // to merge the phone/email and move to that contact.

              // Save the lead with the new contact and then load that page.
              this.lead.contact_id = e.response.data.contact_id;
              await this.save();
              this.$message({
                type: 'success',
                message:
                  'Reservation assigned to exsiting contact. Loading now...',
                showClose: true,
              });
              this.$emit('update:contactId', this.lead.contact_id);
              // this.$router.push('/admin/contacts/view/' + this.lead.contact_id);
            })
            .catch((err) => {
              // Declining the move leaves the lead where it is
              if (err === 'cancel' || err === 'close') {
                return false;
              }
              this.$message({
                type: 'error',
                message:
                  'Error saving lead to the existing contact: ' +
                  processError(err.response ?? err),
                showClose: true,
              });
              return false;
            });
          return false;
        }
        if (e.response.status == 409 && e.response.data.contact_id == 0) {
          // Contact conflicts with 2 different contacts in the system and cant be moved
          this.$message({
            type: 'error',
            message:
              'Reservation exists but the reservation can not be matched to a single contact in the system.  Check for conflicting email and mobile and merge the contacts.',
            showClose: true,
          });
          return false;
        }

        if (e.response.status == 404) {
          // This is still an error but it might be a connector error too
          // If the connector is not found, or the connector url is wrong, etc
          this.$message({
            type: 'error',
            message:
              e.response.message ?? 'Error locating a reservation with that Id',
            showClose: true,
          });
          return false;
        }
        // All other message responses
        if (e.response.message) {
          this.$message({
            type: 'error',
            message: e.response.message,
            showClose: true,
          });
          return false;
        }
        this.$message({
          type: 'error',
          message: 'Unexpected exception linking reservation',
          showClose: true,
        });
        console.error('uncaught exception linking reservation', e);
        return false;
      }

      const folio = status.data.folio;
      const reservationId = status.data.reservation_id;

      let messageType = 'error';
      let message = "Couldn't find Reservation";

      // These responses are yet to be normalized.  Consider how others will respond.
      if (reservationId) {
        this.lead.reservation_id = reservationId;
        // Saves a won status that was waiting on the reservation
        this.doChange('reservation_id');
        messageType = 'success';
        message = 'Found Reservation [' + this.bookingCode + ']';
        try {
          if (folio.arrival_date) {
            this.lead.interest_start_at = new Date(
              folio.arrival_date.split('Z')[0]
            );
          }
          if (folio.departure_date) {
            this.lead.interest_end_at = new Date(
              folio.departure_date.split('Z')[0]
            );
          }
          this.leadDates[0] = this.lead.interest_start_at;
          this.leadDates[1] = this.lead.interest_end_at;
          this.doChange('interest_start_at');
          this.doChange('interest_end_at');
          this.colorClass.interest_start_at = 'element-input-green';
          this.colorClass.interest_end_at = 'element-input-green';
          if (this.lock) {
            this.readOnly.interest_start_at = true;
            this.readOnly.interest_end_at = true;
          }
        } catch (e) {
          console.error('unable to parse dates from connector api: ', e);
        }
        try {
          this.estimatedValueFloat = (+folio.total_revenue / 100).toFixed(2);
          this.lead.estimated_value = folio.total_revenue;
          this.doChange('estimated_value');

          this.colorClass.estimated_value = 'element-input-green';
          if (this.lock) {
            this.readOnly.estimated_value = true;
          }
        } catch (e) {
          console.error(
            'Unable to parse estimated value from connector api: ',
            e
          );
        }
        // Attempt to load adults / children & pets.
        try {
          if (folio.adults) {
            this.lead.quantity_1 = folio.adults;
            this.colorClass.quantity_1 = 'element-input-green';
            this.doChange('quantity_1');
          }
          if (folio.children) {
            this.lead.quantity_2 = folio.children;
            this.colorClass.quantity_2 = 'element-input-green';
            this.doChange('quantity_2');
          }
          if (folio.pets) {
            this.lead.quantity_3 = folio.pets;
            this.colorClass.quantity_3 = 'element-input-green';
            this.doChange('quantity_3');
          }
        } catch (e) {
          console.error(
            'Unable to parse adult / children from connector api: ',
            e
          );
        }

        if (folio.unit_type) {
          this.lead.product_code = folio.unit_type;
          this.colorClass.product_code = 'element-input-green';
          this.doChange('product_code');
        }

        // TODO: get booked unit in there, just a stub for now
        // We dont get units on the connector api endpoint as we only get the
        // raw connector values and not our internal unit ids, pmid at best
        if (folio.units && folio.units.length) {
          this.lead.final_product_id = folio.units[0]?.id;
        }
      }

      this.$message({
        type: messageType,
        message: message,
        showClose: true,
      });

      // TODO this needs to be complete, but it must be optional set by the agent admin
      this.lock = true;
    },
    updateLeadSource(leadSource) {
      // Reset detail on change
      if (leadSource.id != this.lead.source_id) {
        this.lead.source_related_id = null;
        this.lead.source_detail_id = null;
        this.lead.source_detail_related_id = null;
      }
      this.lead.source_id = leadSource.id;
      this.lsRelatedType = leadSource.related_type;
      this.lsdRelatedType = undefined;
      this.doChange('source_id');
      this.doChange('source_detail_id');
      this.doChange('source_detail_related_id');
    },
    updateLeadSourceDetail(lsDetail) {
      if (lsDetail.id != this.lead.source_detail_id) {
        this.lead.source_detail_related_id = null;
      }
      this.lead.source_detail_id = lsDetail.id;
      this.lsdRelatedType = lsDetail.related_type;
      this.doChange('source_detail_id');
      this.doChange('source_detail_related_id');
    },
    updateClosingLeadSource(leadSource) {
      // Reset detail on change
      if (leadSource.id != this.lead.closing_source_id) {
        this.lead.closing_source_related_id = null;
        this.lead.closing_source_detail_id = null;
        this.lead.closing_source_detail_related_id = null;
      }
      this.lead.closing_source_id = leadSource.id;
      this.closingLsRelatedType = leadSource.related_type;
      this.closingLsdRelatedType = undefined;
      this.doChange('closing_source_id');
      this.doChange('closing_source_detail_id');
      this.doChange('closing_source_detail_related_id');
    },
    updateClosingLeadSourceDetail(lsDetail) {
      if (lsDetail.id != this.lead.closing_source_detail_id) {
        this.lead.closing_source_detail_related_id = null;
      }
      this.lead.closing_source_detail_id = lsDetail.id;
      this.closingLsdRelatedType = lsDetail.related_type;
      this.doChange('closing_source_detail_id');
      this.doChange('closing_source_detail_related_id');
    },
    setContact(contactId) {
      this.lead.contact_id = contactId;
      this.doChange('contact_id');
    },
    copyLink() {
      navigator.clipboard.writeText(
        window.location.origin + '/admin/call-center/leads/' + this.lead.id
      );
      this.$message({
        message: 'Link copied to clipboard',
        type: 'success',
        showClose: true,
      });
    },
    async changeTags(tags) {
      this.doChange('tags');
    },
  },
};
</script>
<style lang="scss">
.element-input-green {
  input {
    background: rgb(231, 253, 231);
  }
}
.reservation-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.reservation-connector {
  flex: 1;
  min-width: 120px;
}

.reservation-code {
  flex: 1;
  min-width: 100px;
}

.reservation-button {
  white-space: nowrap;
}

.reservation-required {
  padding: 6px;
  border: 2px solid rgb(var(--v-theme-error));
  border-radius: 6px;
}

.reservation-required-message {
  margin-bottom: 4px;
  font-size: 12px;
  color: rgb(var(--v-theme-error));
}
</style>
